import PropTypes from 'prop-types'
import React from 'react'
// import { useInView } from 'react-intersection-observer'
import { motion } from 'framer-motion'

const Section = ({
  children,
  fullWidth,
  background,
  className,
  type,
  fullHeight,
}) => {
  // Changes the section tag if it's passed as a prop.
  const WrapperTag = type ? type : 'section'

  // // Animation
  // const [ref, inView] = useInView({
  //   triggerOnce: true,
  //   rootMargin: '-100px 0px',
  // })

  // Todo: replace this
  const wrapperStyle = `
    ${fullWidth ? 'px-16' : 'container'}
   z-20 relative
  `

  return (
    <>
      <WrapperTag
        className={`relative ${
          background && background === 'dark'
            ? 'bg-gradient-to-br from-gray-700 to-gray-900 dark-cta'
            : background === 'light'
            ? 'bg-gray-50'
            : background
        }

        ${fullHeight ? 'flex flex-col justify-between flex-auto h-full' : ''}

        `}
      >
        <motion.div
          className={`py-16 ${wrapperStyle}
          ${className ? className : ''}
          ${fullHeight ? 'flex flex-grow' : ''}
          `}
          // initial={{ opacity: 0 }}
          // animate={{ opacity: inView ? 1 : 0 }}
          transition={{
            duration: 0.35,
          }}
        >
          {children}
        </motion.div>
      </WrapperTag>
    </>
  )
}

Section.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Section
